var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoutIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.9997 5.33333L14.6663 8M14.6663 8L11.9997 10.6667M14.6663 8H5.99967M9.99967 2.80269C9.14984 2.29218 8.16317 2 7.11079 2C3.91981 2 1.33301 4.68629 1.33301 8C1.33301 11.3137 3.91981 14 7.11079 14C8.16317 14 9.14984 13.7078 9.99967 13.1973",
  stroke: "#0E1680",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgLogoutIcon;